import React from 'react';
import { Switch } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Provider from './provider';
import AssetUse from './asset-use';
import Asset from './asset';
import PrivateRoute from 'app/shared/auth/private-route';
/* jhipster-needle-add-route-import - JHipster will add routes here */

const Routes = ({ match }) => (
  <div>
    <Switch>
      {/* prettier-ignore */}
      <PrivateRoute path={`${match.url}provider`} component={Provider} hasAnyAuthorities={['ROLE_ROOT']}/>
      <ErrorBoundaryRoute path={`${match.url}asset-use`} component={AssetUse} />
      <ErrorBoundaryRoute path={`${match.url}asset`} component={Asset} />
      {/* jhipster-needle-add-route-path - JHipster will add routes here */}
    </Switch>
  </div>
);

export default Routes;
